class Image_video {
    constructor() {
        this.module = ".avvio-image-video";
        this.video = ".avvio-image-video__video-control";
        this.videoFigure = ".avvio-image-video__figure";
        this.play = '.avvio-image-video__play-button';
        this.pause = '.avvio-image-video__pause-button';
        this.mute = '.avvio-image-video__mute-button';
    }

    init() {
        document.querySelectorAll(this.module).forEach((element) => {
            const videoControl = element.querySelector(this.video);
            if(videoControl) {
                const videoFigure = element.querySelector(this.videoFigure);
                const videoPlay = element.querySelector(this.play);
                const videoPause = element.querySelector(this.pause);
                const videoMute = element.querySelector(this.mute);
                this.mobilePauseVideo(videoFigure);
                this.playVideo(videoPlay, videoControl, videoFigure);
                this.pauseVideo(videoPause, videoControl, videoFigure);
                this.muteVideo(videoMute, videoControl);
                this.endVideo(videoControl, videoFigure);
            }
        });
    }

    mobilePauseVideo(videoFigure) {
        videoFigure.addEventListener('mousedown', function(e) {
            if(videoFigure.classList.contains('avvio-image-video__is-mobile')) {
                if(videoFigure.classList.contains('avvio-image-video__remove-play') && videoFigure.classList.contains('has_hover')) {
                    videoFigure.classList.add("is_hover");
                    videoFigure.classList.remove("has_hover");                    
                } else {
                    videoFigure.classList.remove("is_hover");
                    videoFigure.classList.add("has_hover");
                }
            }
        })
    }

    playVideo(videoPlay, videoControl, videoFigure) { 
        videoPlay.addEventListener("mousedown", function() {
            videoControl.play(); 
            videoFigure.classList.add('avvio-image-video__remove-play');
        });
    } 

    pauseVideo(videoPause, videoControl, videoFigure) { 
        videoPause.addEventListener("mousedown", function() {
            videoControl.pause(); 
            videoFigure.classList.remove('avvio-image-video__remove-play'); 
            videoFigure.classList.remove("has_hover");  
            videoFigure.classList.remove("is_hover");  
        })
    } 

    muteVideo(videoMute, videoControl) { 
        videoMute.addEventListener("mousedown", function(e) {
            e.target.classList.remove('avvio-image-video__mute-button-icon'); 
            e.target.classList.remove('avvio-image-video__unmute-button-icon'); 
            if(videoControl.muted) {
                videoControl.muted = false;
                e.target.classList.add('avvio-image-video__mute-button-icon');
            } else {
                videoControl.muted = true;
                e.target.classList.add('avvio-image-video__unmute-button-icon');
            }
        })
    }  

    endVideo(videoControl, videoFigure) {
        videoControl.onended = function() {
            videoFigure.classList.remove('avvio-image-video__remove-play'); 
            videoFigure.classList.remove("has_hover");  
            videoFigure.classList.remove("is_hover");  
        };
    }
}
const initiateImageVideo = () => {
    const image_video = new Image_video();
    image_video.init();
}



/**
 * Initialize the script when the block is previewed within the editor
 * https://www.advancedcustomfields.com/resources/javascript-api/
 */
 if (window.acf) 
 {
   window.acf.addAction('render_block_preview/type=avvio-image-video', initiateImageVideo);
 }
 else  
 {
  window.addEventListener('load', () => {
    initiateImageVideo();
  });
 }